export default __webpack_public_path__ + "media/color/mtl-e38e40c9.svg";